<template>
  <Icon>
    <svg slot="svg" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <polygon id="path-Remove" points="20.749 4.707 19.334 3.293 12.042 10.586 4.749 3.293 3.334 4.707 10.627 12 3.334 19.293 4.749 20.707 12.042 13.414 19.334 20.707 20.749 19.293 13.456 12"></polygon>
      </defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="icons/Close" transform="translate(-3.000000, -3.000000)">
          <rect id="Bounding-Box-Remove" x="0" y="0" width="24" height="24"></rect>
          <mask id="mask-2-Remove" fill="white">
            <use xlink:href="#path-Remove"></use>
          </mask>
          <g id="Mask"></g>
          <g id="Mixin/Fill/Active" mask="url(#mask-2-Remove)" :fill="fill" fill-rule="evenodd">
            <rect class="remove" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsRemoveIcon",
  components: {
    Icon
  },
  extends: Icon,
  props: {
    fill: {
      type: String,
      default: "#8D99AE"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

svg {
  rect.remove {
    transition: fill $transition-duration;
    &:hover {
      transition: fill $transition-duration;
      fill: $extra-light-blue-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-remove-icon.vue